module.exports = __webpack_public_path__ + "static/media/card-4.53fe4f43.png";